import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ToastContainer position="top-right" autoClose={2000}
        style={{ zIndex: 999999 }}
        className="custom-toast-container" // Apply your custom class here
      />
      <ToastContainer position="top-right" autoClose={2000} />
      <App />
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);
// This is the configuration object for the service worker.
const config = {
  onUpdate: (registration) => {
    // Check if there's a new service worker waiting to be activated.
    const waitingServiceWorker = registration.waiting;

    if (waitingServiceWorker) {
      // Ask the user to refresh to get the new version.
      if (window.confirm("A new version of the app is available. Please refresh to update.")) {
        // Post a message to the waiting service worker to activate it.
        waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });

        // Listen for the state change of the waiting service worker.
        // Once it's 'activated', the new content is available, so reload the page.
        waitingServiceWorker.addEventListener('statechange', (event) => {
          if (event.target.state === 'activated') {
            window.location.reload();
          }
        });
      }
    }
  },
  onSuccess: (registration) => {
    // This runs on the first install when content is cached.
    console.log('Content has been cached for offline use.');
  },
};
// Change this line from .unregister() to .register()
serviceWorkerRegistration.register(config);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
